var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "#E6E6E6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79414 0.0146266C3.20914 0.247127 0.494141 3.38213 0.494141 6.98213V14.2496H4.99414V8.24963H1.99414V6.96713C1.99414 4.08713 4.21414 1.58213 7.08664 1.49963C10.0641 1.41713 12.4941 3.79463 12.4941 6.74963V8.24963H9.49414V14.2496H12.4941H13.9941V6.74963C13.9941 2.87213 10.7241 -0.240373 6.79414 0.0146266Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/icon-music.8bc00e3a44f28ebf3cac6222511645c4.svg";
export { ForwardRef as ReactComponent };